import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { TierMapper } from "./tier.mapper";

import { environment } from "environments/environment";
import { Tier } from "./tier.type";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";

@Injectable()
export class TierRepository extends CrudAbstractRepository {
  getMapper(): any {
    return TierMapper.map;
  }

  getEndpoint(): string {
    return "tier";
  }

  public addTier(model: Tier): Observable<object> {
    return this.http.post(
      `${environment.apiUrl}/${this.getEndpoint()}/${model
        .getDiscriminator()
        .toLowerCase()}`,
      model.getRequestParams(),
    );
  }

  public list(): Observable<Tier[]> {
    return this.http
      .get<object[]>(`${environment.apiUrl}/tier/list`)
      .pipe(map((response) => response.map(this.getMapper())));
  }
}
